import {
  createApiFactory,
  createComponentExtension,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { DevHubEventsClient, devhubEventsApiRef } from './api';
import { rootRouteRef } from './routes';

export const devhubEventsPlugin = createPlugin({
  id: 'devhub-events',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: devhubEventsApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) => new DevHubEventsClient({ discoveryApi, fetchApi }),
    }),
  ],
});

/** Full list of upcoming events, mounted at `/events`. */
export const EventsPage = devhubEventsPlugin.provide(
  createRoutableExtension({
    name: 'EventsPage',
    component: () => import('./components/EventsPage').then(m => m.EventsPage),
    mountPoint: rootRouteRef,
  }),
);

/** Home page card with the next few events and a "See all events" link. */
export const UpcomingEventsCard = devhubEventsPlugin.provide(
  createComponentExtension({
    name: 'UpcomingEventsCard',
    component: {
      lazy: () =>
        import('./components/UpcomingEventsCard').then(m => m.UpcomingEventsCard),
    },
  }),
);
